import icons from '@/components/svg'

export default {
  colors: {
    primary: '#528ef7',
    secondary: '#101e3e',
    error: '#FF726D',
    accent: '#FF726D',
    'osg-gray': '#828282',
    'osg-black': '#2a2a2a',
    'osg-active': '#e7effe',
    'osg-active-border': '#e7effe',
    'osg-active-font': '#528ef7',
    'osg-active-icon': '#1f3261',
    'osg-active-text': '#1f3261',
    'osg-gray-text': '#4f4f4f',
    'osg-gray-2': '#474747',
    'osg-gray-3': '#fafafa',
    'osg-gray-4': '#9e9e9e',
    'osg-gray-5': '#f0f0f0',
    'osg-gray-6': '#949494',
    'osg-gray-7': '#E0E0E0',
    'primary-blue': '#e4f0ff',
    'negative-number': '#EE555A'
  },
  icons: {
    'osg-instagram': {
      component: icons.InstagramIcon
    },
    'osg-linkedin': {
      component: icons.LinkedInIcon
    },
    'osg-website': {
      component: icons.WebsiteIcon
    },
    'osg-error': {
      component: icons.ErrorIcon
    },
    'osg-email': {
      component: icons.EmailIcon
    },
    'osg-chat': {
      component: icons.ChatIcon
    },
    'osg-logo': {
      component: icons.OsiguLogo
    },
    'osg-empty-state': {
      component: icons.EmptyStateIcon
    },
    'osg-biometric-validation': {
      component: icons.BiometricValidationIcon
    },
    'osg-general-error': {
      component: icons.GeneralErrorIcon
    },
    'osg-general-error-v2': {
      component: icons.GeneralErrorIconV2
    },
    'osg-documentation-complete': {
      component: icons.DocumentationCompleteIcon
    },
    'osg-documentation-incomplete': {
      component: icons.DocumentationIncompleteIcon
    },
    'osg-documentation-pending-to-complete': {
      component: icons.DocumentationPendingToCompleteIcon
    },
    'osg-chat-primary': {
      component: icons.ChatIconPrimary
    },
    'osg-chat-disabled': {
      component: icons.ChatIconDisabled
    },
    'osg-chat-secondary': {
      component: icons.ChatIconSecondary
    },
    'osg-account-primary': {
      component: icons.AccountIcon
    },
    'osg-agreements-primary': {
      component: icons.AgreementsIcon
    },
    'osg-minus-grey': {
      component: icons.MinusGreyIcon
    },
    'osg-multiple-account': {
      component: icons.MultipleAccountIcon
    },
    'osg-invoiceable-to-false-icon': {
      component: icons.InvoiceableToFalseIcon
    },
    'osg-fingerprint-validation': {
      component: icons.FingerPrintValidationIcon
    },
    'osg-ai-analysis-icon': {
      component: icons.AiAnalisysIcon
    },
    'osg-upload-file-icon': {
      component: icons.UploadFileIcon
    },
    'osg-risk-icon': {
      component: icons.RiskIcon
    },
    'osg-arrow-right-icon': {
      component: icons.ArrowRightIcon
    }
  }
}
